<template>
  <div class="search-result">
    <div class="search-main">
      <div class="location">
        <img :src="require('../../assets/img/location.png')" alt="">
        搜索结果 “<span style="font-size: 16px;color: #EA5504"> {{ resultKeywords }} </span>”
      </div>
      <div class="search-area">
        <div class="search-input">
          <input v-model="searchParam.keyword" type="text" placeholder="请输入关键字查询">
          <el-select class="searchType result" v-model="searchType"  placeholder="选择类型" style="width: 180px;height: 42px;vertical-align: top;display: inline-block;margin-top: -1px">
            <el-option
              v-for="(value, key) in searchTypeList"
              :key="key"
              :label="value"
              :value="key"
            />
          </el-select>
          <div class="search-button" @click="getData">
            <i v-if="showLoading" class="el-icon-loading"></i>
            <img v-else src="../../assets/img/searchIcon.png" alt="">
          </div>
        </div>
      </div>
      <template v-if="showLoading">
        <div style="width:100%;height: 300px;line-height: 300px;color: #EA5504;font-size: 25px;text-align: center">
          <i class="el-icon-loading"></i>
          搜索中...
        </div>
      </template>
      <template v-else-if="dataList.length <= 0">
        <div style="width:100%;height: 300px;line-height: 300px;color: #999999;font-size: 25px;text-align: center">
          暂无数据 !
        </div>
      </template>
      <template v-else>
        <template v-if="searchType === 'activity'">
          <div v-for="(item, index) in dataList" :key="index" class="course-item">
            <div v-if="item.process" class="enroll" :style="{backgroundColor: $processMapping[item.process].color}">{{ $processMapping[item.process].name }}</div>
            <img v-if="item.coverImg" :src="$urlPrefix + item.coverImg" alt="">
            <div v-else class="coverArea">
              <p>{{ item.activityTitle }}</p>
            </div>
            <div class="details">
              <div :style="{ backgroundColor: sectionList[item.societyCode].color }">
                {{ sectionList[item.societyCode].name }}
              </div>
              <div :style="{ backgroundColor: $typeColorMapping[item.activityType] }">
                {{ $typeMapping[item.activityType] }}
              </div>
              <span class="title" @click="checkDetails(item.pkid, '/activityDetail')">{{ item.activityTitle }}</span>
              <br>
              <p>活动时间: {{ item.startTime }}</p>
              <span class="price-span">
                <template v-if="item.originPrice">
                  <template v-if="item.preferentialPrice || item.preferentialPrice === 0">
                    <span class="old-price">￥{{ item.originPrice }}元/人</span>
                    <span>{{ item.preferentialPrice === 0 ? '免费' : '￥' + item.preferentialPrice + '元/人' }}</span>
                  </template>
                  <span v-else>￥{{ item.originPrice }}元/人</span>
                </template>
                <span v-else>免费</span>
              </span>
            </div>
          </div>
        </template>
        <template v-else-if="searchType === 'specialCourse'">
          <div v-for="(item, index) in dataList" :key="index" class="course-item">
            <img v-if="item.coverImg" :src="$urlPrefix + item.coverImg" alt="">
            <div v-else class="coverArea">
              <p>{{ item.specialTitle }}</p>
            </div>
            <div class="details">
              <div :style="{ backgroundColor: sectionList[item.societyCode].color }">
                {{ sectionList[item.societyCode].name }}
              </div>
              <div :style="{ backgroundColor: $typeColorMapping[item.specialType] }">
                {{ $typeMapping[item.specialType] }}
              </div>
              <span class="title" @click="checkDetails(item.pkid, '/courseMain')">{{ item.specialTitle }}</span>
              <br>
              <p>主讲人：{{ item.keynoteSpeaker }}</p>
              <span class="price-span">
                <template v-if="item.originPrice">
                  <template v-if="item.preferentialPrice || item.preferentialPrice === 0">
                    <span class="old-price">￥{{ item.originPrice }}元/人</span>
                    <span>{{ item.preferentialPrice === 0 ? '免费' : '￥' + item.preferentialPrice + '元/人' }}</span>
                  </template>
                  <span v-else>￥{{ item.originPrice }}元/人</span>
                </template>
                <span v-else>免费</span>
              </span>
            </div>
          </div>
        </template>
        <template v-else-if="searchType === 'society'">
          <div v-for="(item, index) in dataList" :key="index" class="information-item">
            <div class="date">
              <span>{{ item.releaseTime.split(' ')[0].split('-')[2] }}</span><br>
              {{ item.releaseTime.split(' ')[0].split('-')[0] + '-' +  item.releaseTime.split(' ')[0].split('-')[1]}}
            </div>
            <div class="details">
              <div>
                <span class="title" @click="checkDetails(item.pkid, '/informationDetail')">{{ item.infoTitle }}</span>
              </div>
              <br>
              <p>{{ item.societyProfile }}</p>
            </div>
          </div>
        </template>
        <template v-else>
          <div v-for="(item, index) in dataList" :key="index" class="tutor-item">
            <img :src="item.headImg ? $urlPrefix + item.headImg : require('../../assets/img/defaultHead2.png')" alt="">
            <div class="details">
              <span class="title" @click="checkDetails(item.pkid, '/tutorDetail')">{{ item.tutorName }}</span>
              <br>
              <p>{{ item.tutorProfile }}</p>
            </div>
          </div>
        </template>

        <el-pagination
          background
          align="left"
          style="margin: 30px 30px"
          layout="total, prev, pager, next, jumper"
          :current-page="searchParam.pageNumber"
          :page-sizes="[5, 10, 20, 30, 50]"
          :page-size="5"
          :total="totalCount"
          @current-change="handleCurrentChange"
        />
      </template>
    </div>
  </div>

</template>

<script>
export default {
  name: 'SearchResult',
  data() {
    return {
      searchType: '',
      totalCount: 0,
      searchTypeList: {
        activity: '活动',
        specialCourse: '课程',
        tutor: '导师',
        society: '资讯'
      },
      sectionList: {
        'product-moudle': {
          name: '产品研习堂',
          color: '#EA5504'
        },
        'operation-moudle': {
          name: '资本对接营',
          color: '#3A65D3'
        },
        'capital-moudle': {
          name: '运维能力课',
          color: '#05B6B0'
        }
      },
      searchParam: {
        pageNumber: 1,
        pageSize: 5,
        keyword: '',
        searchType: ''
      },
      dataList: [],
      showLoading: false,
      resultKeywords: ''
    }
  },
  created() {
    if (this.$route.query.keywords) {
      this.searchParam.keyword = this.$route.query.keywords
      this.searchParam.searchType = this.$route.query.searchType
      this.searchType = this.$route.query.searchType
      this.getData()
    }
  },
  methods: {
    handleCurrentChange(val) {
      this.searchParam.pageNumber = val
      this.getData()
    },
    checkDetails(pkid, path) {
      this.$router.push({
        path: path,
        query: {
          pkid: pkid,
          pathList: JSON.stringify([
            {
              name: '搜索页',
              path: this.$route.fullPath
            }
          ])
        }
      })
    },
    getData() {
      if (!this.searchParam.keyword) {
        this.$message.warning('请输入搜索内容 !')
        return
      }
      this.showLoading = true
      this.$post('/front/index/globalSearch', this.searchParam).then(res => {
        this.resultKeywords = this.searchParam.keyword
        if (res) {
          this.totalCount = res.total
          this.$emit('getActivityProcess', res.records)
          this.dataList = res.records
        } else {
          this.totalCount = 0
          this.dataList = []
        }
        this.showLoading = false
      })
    }
  },
  watch: {
    searchType(val) {
      this.searchParam.searchType = val
      this.handleCurrentChange(1)
    }
  }
}
</script>

<style lang="scss">
.el-tabs__item {
  line-height: 25px;
  font-size: 16px;
  font-weight: 500;
}
.el-tabs__item:hover {
  color: #EA5504;
}
.el-tabs__item.is-active {
  color: #EA5504;
  font-weight: 600;
}
.el-tabs__active-bar {
  height: 4px;
  background-color: #EA5504;
}
.el-tabs__nav-wrap::after {
  height: 0;
}
</style>

<style lang="scss" scoped>
.search-result {
  background-color: #F6F6F5;
  padding: 30px 0;
  .search-main {
    width: 1200px;
    margin: 0 auto;
    .location {
      width: 1200px;
      font-size: 14px;
      font-weight: 400;
      color: #363942;
      margin: 0 auto 25px auto;
      img {
        vertical-align: middle;
        margin-right: 10px;
      }
    }
    .search-area {
      width: 1200px;
      height: 140px;
      padding: 0 25px;
      box-sizing: border-box;
      background: #FFFFFF;
      overflow: hidden;
      .search-input {
        width: 1150px;
        height: 40px;
        margin-top: 25px;
        background: #FFFFFF;
        border: 1px solid #EA5504;
        overflow: hidden;
        input {
          width: 850px;
          height: 100%;
          margin-left: 20px
        }
        .search-button {
          float: right;
          width: 100px;
          height: 40px;
          line-height: 40px;
          background: #EA5504;
          text-align: center;
          cursor: pointer;
          font-size: 20px;
          color: #FFFFFF;
          img {
            vertical-align: middle;
            margin-top: -5px;
          }
        }
        .search-button:hover {
          opacity: 0.8;
        }
      }
    }
    .course-item {
      position: relative;
      display: inline-block;
      width: 1200px;
      height: 180px;
      margin-top: 30px;
      background: #FFFFFF;
      border-radius: 5px;
      padding: 15px 20px;
      box-sizing: border-box;
      overflow: hidden;
      .enroll {
        position: absolute;
        top: -50px;
        right: -50px;
        width: 100px;
        height: 100px;
        background-color: #0AC18F;
        font-size: 18px;
        color: #FFFFFF;
        line-height: 170px;
        transform: rotate(45deg);
        z-index: 10;
        text-align: center;
      }
      img {
        display: inline-block;
        width: 210px;
        height: 150px;
        border-radius: 5px;
      }
      .details {
        display: inline-block;
        position: relative;
        width: 900px;
        height: 150px;
        margin-left: 30px;
        vertical-align: top;
        text-align: left;
        font-weight: bold;
        color: #333333;
        line-height: 24px;
        font-size: 14px;
        div {
          display: inline-block;
          width: 80px;
          height: 24px;
          background: #EA5504;
          border-radius: 5px;
          text-align: center;
          vertical-align: top;
          margin-top: 7px;
          margin-right: 10px;
          color: #FFFFFF;
        }
        .title {
          font-size: 24px;
          color: #333333;
          line-height: 36px;
          cursor: pointer;
        }
        .title:hover {
          color: #EA5504;
        }
        p {
          width: 100%;
          padding-top: 15px;
          color: #999999;
          font-weight: 500;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .price-span {
          position: absolute;
          left: 0;
          bottom: -5px;
          .old-price {
            font-size: 12px;
            font-weight: 400;
            color: #999999;
            text-decoration: line-through;
            margin-right: 5px
          }
          span {
            color: #EF2727;
            font-size: 16px;
            font-weight: bold
          }
        }
      }
    }
    .course-item:hover {
      box-shadow: 0 5px 8px 0 rgba(51, 51, 51, 0.1);
    }

    .tutor-item {
      position: relative;
      display: inline-block;
      width: 1200px;
      height: 150px;
      margin-top: 30px;
      background: #FFFFFF;
      border-radius: 5px;
      padding: 15px 20px;
      box-sizing: border-box;
      overflow: hidden;
      img {
        display: inline-block;
        width: 120px;
        height: 120px;
        border-radius: 5px;
      }
      .details {
        display: inline-block;
        position: relative;
        width: 1000px;
        height: 120px;
        margin-left: 30px;
        vertical-align: top;
        text-align: left;
        font-weight: bold;
        color: #333333;
        line-height: 24px;
        font-size: 14px;
        div {
          display: inline-block;
          width: 80px;
          height: 24px;
          background: #EA5504;
          border-radius: 5px;
          text-align: center;
          vertical-align: top;
          margin-top: 7px;
          margin-right: 10px;
          color: #FFFFFF;
        }
        .title {
          font-size: 24px;
          color: #333333;
          line-height: 36px;
          cursor: pointer;
        }
        .title:hover {
          color: #EA5504;
        }
        p {
          width: 100%;
          height: 70px;
          padding-top: 10px;
          color: #999999;
          font-weight: 500;
        }
      }
    }
    .tutor-item:hover {
      box-shadow: 0 5px 8px 0 rgba(51, 51, 51, 0.1);
    }

    .information-item {
      position: relative;
      display: inline-block;
      width: 1200px;
      height: 120px;
      margin-top: 30px;
      background: #FFFFFF;
      border-radius: 5px;
      padding: 15px 20px;
      box-sizing: border-box;
      overflow: hidden;
      .date {
        display: inline-block;
        width: 130px;
        height: 100px;
        line-height: 40px;
        color: #F78040;
        font-weight: 600;
        font-size: 24px;
        text-align: center;
        border-right: 2px solid #DCDCDC;
        padding-right: 20px;
        box-sizing: border-box;
        span {
          font-size: 36px;
        }
      }
      .details {
        display: inline-block;
        position: relative;
        width: 980px;
        height: 90px;
        margin-left: 30px;
        vertical-align: top;
        text-align: left;
        font-weight: bold;
        color: #333333;
        line-height: 24px;
        font-size: 14px;
        .typeTab {
          display: inline-block;
          width: 80px;
          height: 24px;
          background: #EA5504;
          border-radius: 5px;
          text-align: center;
          vertical-align: top;
          margin-top: 7px;
          margin-right: 10px;
          color: #FFFFFF;
        }
        div {
          width: 890px;
          display: inline-block;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
        .title {
          font-size: 30px;
          color: #333333;
          line-height: 36px;
          cursor: pointer;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
        .title:hover {
          color: #EA5504;
        }
        p {
          width: 100%;
          height: 50px;
          font-weight: 500;
          overflow: hidden;
          text-overflow: ellipsis ;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          word-break: break-all;
          line-height: 25px;
        }
      }
    }
    .information-item:hover {
      box-shadow: 0 5px 8px 0 rgba(51, 51, 51, 0.1);
    }
  }
}
</style>
